import InviteComp from "src/components/invite/InviteComp";

export default function InvitePage() {
  return (
    <div>
      <InviteComp />
    </div>
  );
}
